import { taxAxios } from '@/utils/taxAxios';

// 埋点记录
export const buriedPoint = (params) => {
  return taxAxios.post(`/api/dbc/taxation/buriedPoint`, params);
}
